document.addEventListener("turbo:load", function () {

    $(document).on("focus keyup","input#user_password", function () {
        let score = 0;
        let a = $(this).val();
        let desc = new Array();

        // strength desc
        desc[0] = "Too short";
        desc[1] = "Weak";
        desc[2] = "Weak";
        desc[3] = "Good";
        desc[4] = "Strong";
        desc[5] = "Best";

        $("#pwd_strength_wrap").fadeIn(400);

        // password length
        if (a.length >= 8) {
            $("#length").removeClass("invalid").addClass("valid");
            score++;
        } else {
            $("#length").removeClass("valid").addClass("invalid");
        }

        // at least 1 digit in password
        if ((a.match(/\d/))) {
            $("#pnum").removeClass("invalid").addClass("valid");
            score++;
        } else {
            $("#pnum").removeClass("valid").addClass("invalid");
        }

        if (a.match(/[!@#$%^&*?_~\-()]/)) {
            $("#spchar").removeClass("invalid").addClass("valid");
            score++;
        } else {
            $("#spchar").removeClass("valid").addClass("invalid");
        }

        // at least 1 capital letter in password
        if ((a.match(/[A-Z]/)) && (a.match(/[a-z]/))) {
            $("#capital-small").removeClass("invalid").addClass("valid");
            score++;
        } else {
            $("#capital-small").removeClass("valid").addClass("invalid");
        }

        if (a.length > 0) {
            //show strength text
            $("#passwordDescription").text(desc[score]);
            // show indicator
            $("#passwordStrength").removeClass().addClass("strength" + score);
        } else {
            $("#passwordDescription").text("Password not entered");
            $("#passwordStrength").removeClass().addClass("strength" + score);
        }
        $("#user_password-error").addClass("d-none");
    });

    $(document).on("focusout","input#user_password",function(){
        $("#pwd_strength_wrap").fadeOut(400);
        $("#user_password-error").removeClass("d-none");
    });

    $(document).on("focus keyup","input#admin_password", function () {
        let score = 0;
        let a = $(this).val();
        let desc = new Array();

        // strength desc
        desc[0] = "Too short";
        desc[1] = "Weak";
        desc[2] = "Weak";
        desc[3] = "Good";
        desc[4] = "Strong";
        desc[5] = "Best";

        $("#pwd_strength_wrap").fadeIn(400);

        // password length
        if (a.length >= 8) {
            $("#length").removeClass("invalid").addClass("valid");
            score++;
        } else {
            $("#length").removeClass("valid").addClass("invalid");
        }

        // at least 1 digit in password
        if ((a.match(/\d/))) {
            $("#pnum").removeClass("invalid").addClass("valid");
            score++;
        } else {
            $("#pnum").removeClass("valid").addClass("invalid");
        }

       if (a.match(/[!@#$%^&*?_~\-()]/)) {
            $("#spchar").removeClass("invalid").addClass("valid");
            score++;
        } else {
            $("#spchar").removeClass("valid").addClass("invalid");
        }

        // at least 1 capital letter in password
        if ((a.match(/[A-Z]/)) && (a.match(/[a-z]/))) {
            $("#capital-small").removeClass("invalid").addClass("valid");
            score++;
        } else {
            $("#capital-small").removeClass("valid").addClass("invalid");
        }

        if (a.length > 0) {
            //show strength text
            $("#passwordDescription").text(desc[score]);
            // show indicator
            $("#passwordStrength").removeClass().addClass("strength" + score);
        } else {
            $("#passwordDescription").text("Password not entered");
            $("#passwordStrength").removeClass().addClass("strength" + score);
        }
    });

    $(document).on("focusout","input#admin_password",function(){
        $("#pwd_strength_wrap").fadeOut(400);
    });

});